import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IHelpCategory, IHelpLanguage, IHelpQuestion, IMarketHelpModal } from '../types/market-help.type';

interface InitialState {
  isLoading: boolean;
  helpLanguages: IHelpLanguage[];
  helpCategories: IHelpCategory[];
  selectedLanguage: IHelpLanguage | null;
  selectedCategory: IHelpCategory | null;
  selectedQuestion: IHelpQuestion | null;
  currentModal: IMarketHelpModal | null;
}

const initialState: InitialState = {
  isLoading: false,
  helpLanguages: [],
  helpCategories: [],
  selectedLanguage: null,
  selectedCategory: null,
  selectedQuestion: null,
  currentModal: null,
};

export const marketHelp = createSlice({
  name: 'marketHelp',
  initialState: initialState,
  reducers: {
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setHelpLanguages(state, action: PayloadAction<IHelpLanguage[]>) {
      state.helpLanguages = action.payload;
    },
    setSelectedLanguage(state, action: PayloadAction<IHelpLanguage | null>) {
      state.selectedLanguage = action.payload;
    },
    setSelectedCategory(state, action: PayloadAction<IHelpCategory | null>) {
      state.selectedCategory = action.payload;
    },
    setHelpCategories(state, action: PayloadAction<IHelpCategory[]>) {
      state.helpCategories = action.payload;
    },
    setCurrentModal(state, action: PayloadAction<IMarketHelpModal | null>) {
      state.currentModal = action.payload;
    },
    setSelectedQuestion(state, action: PayloadAction<IHelpQuestion | null>) {
      state.selectedQuestion = action.payload;
    },
    clearState(state) {
      state = initialState;
      return state;
    },
  },
});

export const {
  setIsLoading,
  setHelpLanguages,
  setSelectedLanguage,
  setSelectedCategory,
  clearState,
  setHelpCategories,
  setCurrentModal,
  setSelectedQuestion,
} = marketHelp.actions;
